export default __webpack_public_path__ + "static/1208-6ccd9f9b576f81f98f93264c9181466f.gif";